import React, { useEffect, useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import { postPrivacyPolicyAgreements } from 'apis/me'
import loadingModules from 'modules/loading'
import { useDispatch, useSelector } from 'react-redux'
import alertModules from 'modules/alert'
import meModules, { getAcceptedPrivacyPolicy, getIsSignin } from 'modules/me'
import { RootState } from 'store'

// https://dev.yoor.jp/management/door/members
export default function PrivacyPolicyModal(props: { open?: boolean }) {
  const acceptedPrivacyPolicy = useSelector((state: RootState) =>
    getAcceptedPrivacyPolicy(state)
  )
  const isSignin = useSelector((state: RootState) => getIsSignin(state))
  const [open, setOpen] = useState(isSignin && !acceptedPrivacyPolicy)
  const dispatch = useDispatch()

  const accept = async () => {
    try {
      dispatch(loadingModules.actions.start())
      await postPrivacyPolicyAgreements()
      dispatch(
        alertModules.actions.setAlert({
          text: '同意しました',
          severity: 'success'
        })
      )
      dispatch(meModules.actions.setAcceptedPrivacyPolicy(false))
    } finally {
      setOpen(false)
      dispatch(loadingModules.actions.stop())
    }
  }

  return (
    <>
      <Dialog open={open}>
        <Modal className="modal" id="modal-door">
          <ModalTitle>個人情報の取り扱いについて(YOOR)<br />一部改訂のお知らせ</ModalTitle>
          <ModalDescription>個人情報の取り扱いについて(YOOR)を一部改訂いたしました。<br />YOORを引き続きご利用いただくために改めて同意をお願いします。</ModalDescription>
          <ModalContents>
            <PrivacyPolicy><a href="/privacy" target="_blank">個人情報の取り扱いについて(YOOR)</a></PrivacyPolicy>
            <ModalBtnWrap>
              <AgreeButton onClick={() => {accept()}}>同意する</AgreeButton>
              <ContactLink href="https://form.run/@seesaa-0040" target="_blank">お問い合わせ</ContactLink>
            </ModalBtnWrap>
          </ModalContents>
        </Modal>
      </Dialog>
    </>
  )
}

const Modal = styled.section`
  width: 100%;
  max-width: 640px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
  @media (max-width: 640px) {
    width: 92vw;
    padding: 24px 20px;
  }
`
const ModalTitle = styled.h2`
  font-size: 18px;
  text-align: center;
  margin-bottom: 16px;
`
const ModalDescription = styled.p`
  font-size: 14px;
  margin-bottom: 16px;
`
const ModalContents = styled.div`
  width: 100%;
`
const PrivacyPolicy = styled.p`
  text-align: center;
  font-size: 14px;
  margin-bottom: 16px;
  a {
    color: #26BFDB;
    &:hover {
      opacity: .8;
    }
  }
`
const ModalBtnWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`
const AgreeButton = styled.button`
  width: 100%;
  max-width: 516px;
  height: 54px;
  line-height: 54px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  background: #26BFDB;
  border: 0;
  outline: none;
  border-radius: 9999px;
  cursor: pointer;
  @media (max-width: 640px) {
    height: 48px;
    line-height: 48px;
  }
  &:hover {
    opacity: .8;
  }
`
const ContactLink = styled.a`
  font-size: 14px;
  color: #888888;
  &:hover {
    opacity: .8;
  }
`
